import type { ICellRendererParams } from 'ag-grid-community';
import { formatDate, formatRelativeTime } from '@utils/format';
import type { NewsArticle } from '../../schema';

/**
 * Two-line cell:
 *   primary  → publishedAt (or em-dash if unpublished)
 *   muted    → "Updated <relative> ago" using updatedAt
 * Mirrors the reference's date column.
 */
export function PublishedCell(p: ICellRendererParams<NewsArticle>) {
  if (!p.data) return null;
  const { publishedAt, updatedAt } = p.data;
  return (
    <div className="flex flex-col leading-tight">
      <span className="text-[13px] font-semibold text-foreground">
        {publishedAt ? formatDate(publishedAt) : '—'}
      </span>
      {updatedAt && (
        <span className="mt-0.5 text-[11px] text-foreground-muted">
          Updated {formatRelativeTime(updatedAt)}
        </span>
      )}
    </div>
  );
}
